import { useEffect, useState } from "react";
import { Task, TaskCatalogResponse } from "src/types/tasks";

interface UseTasksReturn {
  tasks: Task[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useFetchTasks(): UseTasksReturn {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [refetchTrigger, setRefetchTrigger] = useState<number>(0);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/tasks/task-catalog`
        );

        if (!response.ok) {
          throw new Error(
            `Failed to fetch tasks: ${response.status} ${response.statusText}`
          );
        }

        const data: TaskCatalogResponse = await response.json();

        if (data.success && data.data) {
          setTasks(data.data);
        } else {
          throw new Error("Invalid response format");
        }
      } catch (err) {
        console.error("Error fetching tasks:", err);
        setError(err instanceof Error ? err.message : "Failed to load tasks");
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [refetchTrigger]);

  const refetch = () => {
    setRefetchTrigger((prev) => prev + 1);
  };

  return { tasks, loading, error, refetch };
}
